import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { EntrySidePanel } from '../components/entrySidePanel';
import { NewsContents } from './newsContents';
export const NewsPanel = () => {
    return (_jsx(EntrySidePanel, { title: '\uD83D\uDCF0 News', children: _jsx(NewsContents, { numItemsPerPage: 3 }) }));
};
